import classnames from 'classnames'
import * as React from 'react'

import {DMColors} from '../types'

type BadgeStyle = 'square' | 'pill' | 'interactive'
type BadgeSize = 'sm'

interface BaseProps {
  style: BadgeStyle
  size?: BadgeSize
  displayClasses?: string
  onClick?: (ev: React.MouseEvent<HTMLElement>) => void
  dataSeleniumTarget?: string
}

export type SquareColor =
  | 'blue'
  | 'green'
  | 'red'
  | 'dark-red'
  | 'yellow'
  | 'grey-40'

export interface Props extends BaseProps {
  style: 'pill' | 'interactive'
  foreground: DMColors
  background: DMColors
  size?: BadgeSize
}

export interface SquareProps extends BaseProps {
  style: 'square'
  color?: SquareColor
}

const Badge: React.FC<React.PropsWithChildren<Props | SquareProps>> = (
  props
) => {
  const styleCls = `badge--${props.style}`
  const classes: {[key: string]: boolean} = {}
  if (props.size) {
    classes[props.size] = true
  }
  switch (props.style) {
    case 'interactive':
    case 'pill':
      classes[`u-${props.foreground}`] = true
      classes[`u-bg-${props.background}`] = true
      break
    case 'square':
      if (props.color) {
        classes[`badge--square__${props.color}`] = true
      }
      break
    default:
      const msg: never = props
      throw new TypeError(`invalid type: ${msg}`)
  }
  const cls = classnames(styleCls, props.displayClasses, classes)

  return props.onClick ? (
    <button
      className={cls}
      onClick={props.onClick}
      data-selenium-target={`${props.dataSeleniumTarget}-bt`}
    >
      {props.children}
    </button>
  ) : (
    <span
      className={cls}
      onClick={props.onClick}
      data-selenium-target={props.dataSeleniumTarget}
    >
      {props.children}
    </span>
  )
}

export default Badge
